var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('masonry',{staticClass:"masonry-container retailer-exhibits",attrs:{"cols":{ default: 5, 1700: 5, 1300: 4, 900: 3, 600: 2 },"gutter":{
        default: '35px',
        1300: '35px',
        900: '2.5vw',
        600: '3vw',
        599: '15px'
    }}},_vm._l((_vm.exhibits),function(image,index){return _c('div',{key:'picture-' + index >= 2 ? _vm.extra : index,staticClass:"retailer-exhibits__image"},[_c('a',{on:{"click":function($event){return _vm.showImage(image.Url)}}},[_c('div',{domProps:{"innerHTML":_vm._s(image.Html)}}),_c('span',{staticClass:"cta-link"},[_vm._v(_vm._s(image.Title))])])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }